import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { AUTH_OPTIONS } from "../../auth.options";
import { getDeepFromObject } from "../../helpers";
import { Register } from "../../models/vta.register";
import { ApiService } from "../../services/api.service";
import { Constant } from "../../constant/constant";
import { NgForm } from "@angular/forms";
import { ToastService } from "../../../../../@core/services/toast.service";
import {
  AnimationSettingsModel,
  SpinSettingsModel,
} from "@syncfusion/ej2-splitbuttons";
import { CommonService } from "../../services/common.service";

@Component({
    selector: "register",
    styleUrls: ["./vta.register.component.scss"],
    templateUrl: "./vta.register.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RegisterComponent implements OnInit {
  user: Register = new Register();
  registerActionMessage: string;
  showSuccessMessage: boolean = false;
  showErrorMessage: boolean = false;
  loading: boolean = false;
  slideRight: AnimationSettingsModel = { effect: "SlideRight" };
  spinCenter: SpinSettingsModel = { position: "Center" };
  constructor(
    private apiService: ApiService,
    private toast: ToastService,
    private constant: Constant,
    @Inject(AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected router: Router,
    private commonService: CommonService
  ) {}

  ngOnInit() {}

  register(form: NgForm): void {
    const payload = this.createPayload(this.user);

    if (
      this.isValidEmail(this.user.email) &&
      this.isValidEmail(this.user.reEmail)
    ) {
      this.loading = true;
      this.apiService.createOrganization(payload).subscribe(
        (data) => {
          this.showSuccessMessage = true;
          this.registerActionMessage = this.constant.REGISTER_MSG.SUCCESS;
          this.loading = false;
          form.resetForm();
        },
        (err) => {
          this.showErrorMessage = true;
          this.registerActionMessage = this.constant.REGISTER_MSG.FAILURE;
          this.toast.error(this.registerActionMessage);
          this.loading = false;
          form.resetForm();
        },
        () => {}
      );
    }
  }

  createPayload(user: Register) {
    let name = {
      first: (user || {}).firstName || "",
      middle: (user || {}).middleName || "",
      last: (user || {}).lastName || "",
    };
    let registerData = {
      email: (this.user || {}).email || "",
      name: name,
    };
    let admin = [];
    admin.push(registerData);

    const actionPayload = {
      name: (this.user || {}).name || "",
      admins: admin,
    };
    return actionPayload;
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  isValidEmail = (email: string) => {
    return this.commonService.validateEmail(email);
  };
}
